import React from "react";
import "./shotChart.css";

/*interface PopUpProps {
  pct: any;
  totals: any;
  color: string;
}*/

export default class PopUp extends React.Component  {
  render() {
    const { pct, totals, color } = this.props;
    let css = `.color{
      border-left: ${color} 50px solid
    }`
    //console.log('popup')
    return (
      <div className="hoverDisplay color">
        <style>{css}</style>
        <div className = "hoverText">

          {(totals["shot"]===0)? <p>N/A</p>:<p>{pct}%</p>}
          <p>
            {totals["made"]} out of {totals["shot"]}
          </p>
        </div>
      </div>
    );
  }
}
